import TransactionalFee from "@/models/Products/ProductFees/TransactionalFee";

export default class UpdateTransactionalFeeRequest extends TransactionalFee {

    public constructor(fee: TransactionalFee) {
        super();
        if (fee) {
            this.id = fee.id;
            this.name = fee.name;
            this.reference = fee.reference;
            this.transactionType = fee.transactionType;
            this.subTransactionType = fee.subTransactionType;
            this.fixedAmount.amount = fee.fixedAmount.amount;
            this.fixedAmount.currency = fee.fixedAmount.currency;
            this.percentage = fee.percentage;
            this.includeAmountInPercentage = fee.includeAmountInPercentage;
        }
    }
}